import {DeepLinkActionBase} from '../deep-link-action-base';

export class MyAccountDeepLinkAction extends DeepLinkActionBase {

  async execute(): Promise<void> {
    let tabId = this.descriptor.actionParams && this.descriptor.actionParams.id;
    await this.services.externalLinks.openMyAccount({
        tabId: tabId
      }, this.descriptor.marketingParams,
      true);
  }

}
